import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
  delay,
} from "redux-saga/effects"

import { GET_PROFILE_START, CREATE_PROFILE_START } from "./actionTypes"

import { createProfileSuccess, createProfileError } from "./actions"

import { GetProfileSuccess, GetProfileError } from "./actions"

import { createProfile, getProfile } from "./api"

// CREATE PRofile
function* updateprofileAsync({ payload }) {
  try {
    const response = yield call(createProfile, payload.profileDetails)
    if (response.status === 200) {
      yield delay(500)
      yield put(createProfileSuccess(response.data))
    } else {
      yield put(createProfileError(response.data))
    }
  } catch (error) {
    yield put(createProfileError(error.response.data))
  }
}

function* getProfileAsync() {
  try {
    const response = yield call(getProfile)

    if (response.status === 200) {
      yield delay(500)
      localStorage.setItem('type',response.data.premium_type)
      localStorage.setItem('id',response.data.user_data.id)

      yield put(GetProfileSuccess(response.data))
    } else {
      yield put(GetProfileError(response.message))
    }
  } catch (error) {
    // Handle errors here
    yield put(GetProfileError(error.response.data))
  }
}

function* ProfileSaga() {
  yield takeLatest(CREATE_PROFILE_START, updateprofileAsync),
    yield takeLatest(GET_PROFILE_START, getProfileAsync)
}

export default ProfileSaga
